import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { StorageService } from '../../shared/storage.service';
import { CommonService } from '../../shared/common.service';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { HttpClient } from '@angular/common/http';
import { FooterService } from '../../components/footer/footer.service';
import { Router } from '@angular/router';
const countryData = require('../country-code.json');
declare var $: any;

@Component({
  selector: 'app-trending-festival',
  templateUrl: './trending-festival.component.html',
  styleUrls: ['./trending-festival.component.css']
})
export class TrendingFestivalComponent implements OnInit, AfterViewInit {
  customInqForm: FormGroup;
  customInqSubmitted = false;
  PlaceList: any = [];
  trendingFestivalPackages: any = [];
  noOfPersonError: string;
  countries: any[] = [];
  minDate: string;
  minStartDate: any;
  minEndDate: any;
  endDateBeforeStartDate: boolean = true;
  errorMessage: string = '';
  countryData = countryData;
  showOtherTextbox = false;
  otherService = '';
  datePickerConfig: Partial<BsDatepickerConfig>;
  countdown: string = '';
  intervalId: any;

  constructor(
    private router: Router,
    public storageService: StorageService,
    public commonService: CommonService,
    public userLayoutService: UserLayoutService,
    private fb: FormBuilder,
    private http: HttpClient,
    private footerService: FooterService
  ) { }

  ngOnInit(): void {
    this.datePickerConfig = {
      containerClass: 'theme-dark-blue',
      dateInputFormat: 'MMM DD, YYYY',
      showWeekNumbers: false,
    };
    this.defaultAddCustomInqForm();
    this.footerService.showFooter();
    if (localStorage.getItem('bookingDetails')) {
      localStorage.removeItem('bookingDetails');
    }
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    this.minDate = `${year}-${month}-${day}`;
    this.getTrendingFestivalPackagesList();
    this.getPlaceListData();
    this.minStartDate = today;
    this.minEndDate = this.minStartDate;
  }

  ngAfterViewInit(): void {
    // Initialize the Slick carousel
    setTimeout(() => {
      $('.slider-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: true,
        focusOnSelect: true,
        autoplay: false, // Disable autoplay
        responsive: [
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }, 0.5);
  }

  defaultAddCustomInqForm(): void {
    this.customInqForm = this.fb.group({
      email: ['', [Validators.required, this.customEmailValidator()]],
      phoneNumber: ['', [Validators.required, Validators.pattern(/^\d{8,12}$/)]],
      countryCode: ['+1', [Validators.required]],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      adults: [1, Validators.required],
      children: [0, Validators.required],
      child: [0, Validators.required],
      startCity: [null, Validators.required],
      endCity: [null, Validators.required],
      placeName: ['', Validators.required],
      isSameAsWhatsApp: [false],
      hotel: [false],
      car: [false],
      activities: [false],
      contactPerson: ['', Validators.required],
      comments: [''],
      otherService: [''],
      childAges: this.fb.array([])
    });

    this.customInqSubmitted = false;
    this.noOfPersonError = '';
  }

  customEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const isValidEmail = emailPattern.test(control.value);
      return isValidEmail ? null : { 'invalidEmail': true };
    };
  }

  searchByName(term: string, item: any): boolean {
    term = term.toLowerCase();
    return item.name.toLowerCase().includes(term) || item.dialCode.toLowerCase().includes(term);
  }

  mobilenumberInput(event: any): void {
    const input = event.target;

    input.value = input.value.replace(/[^0-9]/g, '');

    this.customInqForm.patchValue({
      phoneNumber: input.value || null,
    });
  }

  increaseCount(category: string): void {
    const currentValue = this.customInqForm.get(category)?.value || 0;
    this.customInqForm.get(category)?.setValue(currentValue + 1);
  }

  decreaseCount(category: string): void {
    const currentValue = this.customInqForm.get(category)?.value || 0;
    if (currentValue > 0) {
      this.customInqForm.get(category)?.setValue(currentValue - 1);
    }
  }

  increaseCountchild(type: string, isToddler: boolean): void {
    if (type === 'children' || type === 'child') {
      const currentChildren = this.customInqForm.get('children')?.value || 0;
      const currentToddlers = this.customInqForm.get('child')?.value || 0;
      let childControl;
      // Increase the appropriate counter
      if (isToddler) {
        this.customInqForm.get('child')?.setValue(currentToddlers + 1);
        childControl = this.fb.group({
          age: ['', [Validators.required, Validators.min(0), Validators.max(4)]],
          isToddler: [isToddler]
        });
      } else {
        this.customInqForm.get('children')?.setValue(currentChildren + 1);
        childControl = this.fb.group({
          age: ['', [Validators.required, Validators.min(5), Validators.max(11)]],
          isToddler: [isToddler]
        });
      }

      (this.customInqForm.get('childAges') as FormArray).push(childControl);
    }
  }

  decreaseCountchild(type: string, isToddler: boolean): void {
    if (type === 'children' || type === 'child') {
      const currentChildren = this.customInqForm.get('children')?.value || 0;
      const currentToddlers = this.customInqForm.get('child')?.value || 0;

      if (isToddler && currentToddlers > 0) {
        this.customInqForm.get('child')?.setValue(currentToddlers - 1);
      } else if (!isToddler && currentChildren > 0) {
        this.customInqForm.get('children')?.setValue(currentChildren - 1);
      }

      const childAgesArray = this.customInqForm.get('childAges') as FormArray;

      for (let i = childAgesArray.length - 1; i >= 0; i--) {
        const control = childAgesArray.at(i);
        if (control.get('isToddler')?.value === isToddler) {
          childAgesArray.removeAt(i);
          break;
        }
      }
    }
  }

  getChildrenControls() {
    return (this.customInqForm.get('childAges') as FormArray).controls.filter(control => !control.get('isToddler')?.value);
  }

  getToddlersControls() {
    return (this.customInqForm.get('childAges') as FormArray).controls.filter(control => control.get('isToddler')?.value);
  }

  addChildAgeControl(): void {
    const control = this.fb.control('', [Validators.required, Validators.min(0), Validators.max(18)]);
    this.childAges.push(control);
  }

  removeChildAgeControl(): void {
    this.childAges.removeAt(this.childAges.length - 1);
  }

  toggleOther(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    this.showOtherTextbox = checkbox.checked;
    if (!checkbox.checked) {
      this.otherService = ''; // Clear the textbox when unchecked
    }
  }

  trimWhitespace(event: any): void {
    const input = event.target;
    input.value = input.value.trim();
  }

  goToNext(): void {
    // Manually go to the next slide
    $('.slider-nav').slick('slickNext');
  }

  goToPrev(): void {
    // Manually go to the previous slide
    $('.slider-nav').slick('slickPrev');
  }

  addCustomPlace = (term) => ({ id: term, names: term });

  validateCountryCode(event: any): void {
    const input = event.target;
    if (!/^(\+?\d*)$/.test(input.value)) {
      input.value = input.value.replace(/[^0-9+]/g, '');
    }
  }

  onStartDateChange(date: any) {
    this.customInqForm.get('startDate')?.setValue(date);
    const startDate = this.customInqForm.get('startDate')?.value;
    if (startDate) {
      this.minEndDate = startDate;
      this.endDateBeforeStartDate = true;
    } else {
      this.endDateBeforeStartDate = false;
      this.customInqForm.get('endDate')?.setValue(null);
    }
  }

  onEndDateChange(date: any) {
    this.customInqForm.get('endDate')?.setValue(date);
    const startDate = this.customInqForm.get('startDate')?.value;
    const endDate = this.customInqForm.get('endDate')?.value;

    if (startDate) {
      this.endDateBeforeStartDate = true;
    } else {
      this.endDateBeforeStartDate = false;
      this.customInqForm.get('endDate')?.setValue(null);
    }
  }

  onImageError(event: any) {
    event.target.src = 'assets/images/safenet_logo_new.png';
  }

  get personError() {
    let adults = parseInt(this.customInqForm.value.adults);
    let children = parseInt(this.customInqForm.value.children);

    if ((adults + children) == 0) {
      this.noOfPersonError = "Atleast 1 traveler required.";
      return true
    } else if (children > 0 && adults == 0) {
      this.noOfPersonError = "Atleast 1 Adult required."
      return true
    } else {
      this.noOfPersonError = ""
      return false
    }
  }

  searchByName1(term: string, item: any): boolean {
    term = term.toLowerCase();
    return item.name.toLowerCase().includes(term) || item.dial_code.toLowerCase().includes(term) || item.code.toLowerCase().includes(term);
  }

  get childAges() {
    return (this.customInqForm.get('childAges') as FormArray);
  }

  convertToISOFormat(dateString: string): string {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      throw new Error("Invalid date string provided.");
    }

    return date.toISOString();
  }

  getTrendingFestivalPackagesList() {
    this.userLayoutService.getTrendingFestivalPackagesList({ searchTerm: 'holi' }).subscribe((Response: any) => {
      if (Response.code == 1) {
        this.trendingFestivalPackages = Response.data;
      } else {
        console.warn("Failed to retrieve category details");
      }
    }, (error) => {
      console.error("Error fetching category details:", error.error.Message);
    });
  }
  getPlaceListData() {
    this.userLayoutService.getPlaceList().subscribe((Response: any) => {
      if (Response.code == 1) {
        // Case-insensitive filter for Prayagraj, Varanasi, Lucknow, Delhi, and Ayodhya
        this.PlaceList = Response.data.filter((city: any) =>
          ['mathura', 'barsana', 'vrindavan', 'agra'].includes(city.names.toLowerCase())
        );
      } else {
        console.warn("Failed to retrieve category details");
      }
    }, (error) => {
      console.error("Error fetching category details:", error.error.Message);
    });
  }

  AddCustomInquiry() {
    this.customInqSubmitted = true;

    const childAgesArray = this.customInqForm.get('childAges') as FormArray;
    if (this.customInqForm.invalid || this.personError || childAgesArray.invalid) {
      childAgesArray.controls.forEach((control) => control.markAsTouched());
      return;
    }

    const selectedPlaceIds = this.customInqForm.value.placeName;
    const placeIdToSend = selectedPlaceIds.map((place: any) => ({ placeId: place }));
    const childAges = childAgesArray.value.map((age: any) => ({ age }));

    const payload = {
      email: this.customInqForm.value.email,
      phoneNumber: this.customInqForm.value.phoneNumber,
      startDate: this.convertToISOFormat(this.customInqForm.value.startDate),
      endDate: this.convertToISOFormat(this.customInqForm.value.endDate),
      adults: this.customInqForm.value.adults,
      children: this.customInqForm.value.children,
      toddler: this.customInqForm.value.child,
      startCity: this.customInqForm.value.startCity,
      endCity: this.customInqForm.value.endCity,
      trendingFestivalPlaceId: placeIdToSend,
      isSameAsWhatsApp: this.customInqForm.value.isSameAsWhatsApp,
      hotel: this.customInqForm.value.hotel,
      car: this.customInqForm.value.car,
      activities: this.customInqForm.value.activities,
      contactPerson: this.customInqForm.value.contactPerson,
      comments: this.customInqForm.value.comments,
      countryCode: this.customInqForm.value.countryCode,
      otherService: this.customInqForm.value.otherService,
      childrenAgeDetails: this.customInqForm.value.childAges,
      festival: 'Holi',
    };

    this.userLayoutService.trendingFestivalInquiry(payload).subscribe(
      (Response: any) => {

        if (Response.code === 1) {
          this.commonService.notifier.notify('success', "We have received your request. MyYatra360 team will reach out to you at the earliest.");
          this.defaultAddCustomInqForm();

          this.customInqSubmitted = false;
        } else {
          this.commonService.notifier.notify('error', Response.message);
        }
      },
      (error) => {
        this.commonService.notifier.notify('error', error);
      }
    );
  }

  packageDetails(packageId: any) {
    this.router.navigate(['packages-details'], {
      queryParams: { PackageId: packageId }
    });
  }

}
